import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import GeoAuth from '../dataSources/geo/GeoAuth'
import jwtDecode, { JwtPayload } from 'jwt-decode'
import { DataAction, EmptyAction, MessageAction } from '../CustomTypes'

export const REDIRECT = 'REDIRECT_ACTION_REDIRECT'
export const REDIRECT_DONE = 'REDIRECT_ACTION_REDIRECT_DONE'

export interface RedirectBundle {
    path: string | undefined
}

interface RedirectActions {
  redirect: (path: string | undefined) => DataAction<RedirectBundle>,
  redirectDone: () => EmptyAction
}

export const redirectActions: RedirectActions = {
    redirect: (path: string | undefined) : DataAction<RedirectBundle> => {
        return {
            type: REDIRECT,
            data: {path},
        }
    },
    redirectDone: () => {
        return {
            type: REDIRECT_DONE,
            payload: {},
        }
    }
}